import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Login from "../pages/login/Login";
import parseToken from "../common/helpers/token";

function getToken() {
  return location.hash.substring(1);
}

export default function TokenGuard() {
  const [valid, setValid] = useState<boolean | null>(null);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setValid(false);
      return;
    }
    parseToken(token)
      .then(() => setValid(true))
      .catch(() => setValid(false));
  }, []);

  if (valid === null) return null;
  return valid ? <Login /> : <Navigate to="/landing" replace />;
}
